import { flowRight, isEqual } from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import classnames from 'classnames';

import twemoji from 'twemoji';
import linkifyHtml from 'linkifyjs/html';

const htmlifyMessage = flowRight(twemoji.parse, linkifyHtml);

const reorder = (list, startIndex, endIndex) => {
  const resultArray = Array.from(list);
  const [removed] = resultArray.splice(startIndex, 1);
  resultArray.splice(endIndex, 0, removed);
  const result = resultArray.map((question, index) => ({ ...question, order: index + 1 }));

  return result;
};

const getItemStyle = (_, draggableStyle) => ({
  margin: '0 0 1rem 0',
  userSelect: 'none',

  // change background colour if dragging
  // background: isDragging ? 'lightgray' : 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

export default class Questions extends PureComponent {
  static propTypes = {
    onDragEnd: PropTypes.func.isRequired,
    openingId: PropTypes.string.isRequired,
    questions: PropTypes.array.isRequired,
    removeQuestion: PropTypes.func.isRequired,
    setPreviewQuestion: PropTypes.func.isRequired,
  };

  state = {
    questions: this.props.questions,
  };

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.questions, this.props.questions)) {
      this.setState({ questions: nextProps.questions });
    }
  }

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const questions = reorder(this.state.questions, result.source.index, result.destination.index);

    this.setState({ questions }, () => {
      this.props.onDragEnd(this.state.questions);
    });
  };

  render() {
    const { questions } = this.state;
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="interview-questions-droppable">
          {provided => (
            <div className="interview-questions-list" ref={provided.innerRef}>
              {questions.map((question, index) => {
                const activeId = question.id || question.existingId || question.tempId;
                const isDeleteDisable = !question.id && !question.existingId;
                return (
                  <Draggable draggableId={activeId} index={index} key={activeId}>
                    {(provided, snapshot) => (
                      <div
                        className="interview-questions-item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                      >
                        <div
                          className={classnames(
                            'interview-questions-bubble',
                            snapshot.isDragging && 'dragging-question',
                          )}
                          dangerouslySetInnerHTML={{ __html: htmlifyMessage(question.question) }}
                          onClick={() => this.props.setPreviewQuestion(question)}
                        />
                        <span
                          className={classnames(
                            'ui-icon-dismiss-slim interview-questions-item__remove',
                            isDeleteDisable && 'interview-questions-item__remove--disable',
                          )}
                          onClick={() => {
                            this.props.removeQuestion(question);
                          }}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}
